//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from '@/components/Button'
import { debounce } from 'quasar'

export default {
  components: {
    Button
  },

  props: {
    title: String,
    button: String,
    options: Array,
    placeholder: String,
    debounce: {
      type: Boolean,
      default() {
        return true
      }
    }
  },

  data() {
    return {
      search: '',
      tags: []
    }
  },

  computed: {
    sidebarSearch() {
      return this.$store.state.sidebarSearch
    },
    sidebarTags() {
      return this.$store.state.sidebarTags
    }
  },

  created() {
    this.search = this.sidebarSearch
    this.tags = this.sidebarTags
    this.updateSearch = debounce(this.updateSearch, this.debounce ? 300 : 0)
  },

  watch: {
    search() {
      this.updateSearch()
    },
    tags() {
      this.$store.commit('set', ['sidebarTags', this.tags]) // Update store value if tags value is changed
      this.$emit('tags', this.tags)
    },
    sidebarSearch() {
      this.search = this.sidebarSearch // Update search value if store value is changed
    },
    sidebarTags() {
      this.tags = this.sidebarTags // Update tags value if store value is changed
    }
  },

  methods: {
    updateSearch() {
      this.$store.commit('set', ['sidebarSearch', this.search]) // Update store value if search value is changed
      this.$emit('search', this.search)
    }
  }
}
